import { Component, EventEmitter, Input, Output } from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'app-change-visibility-modal',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './change-visibility-modal.component.html',
})
export class ChangeVisibilityModalComponent {
  @Input() modalTitle = '';
  @Input() modalDescription = '';
  @Input() confirmBtnText = '';
  @Input() cancelBtnText = 'Cancel';
  @Output() closeModal = new EventEmitter<boolean>();
  @Output() changeVisibility = new EventEmitter<boolean>();
}
